module.exports = __webpack_public_path__ + "img/fontSize_select.3c2f5836.svg";